import React from 'react';

import { useGlobalModalsContext } from 'contexts/globalModalsContext';
import Link from 'ui/Link';
import { Text } from 'ui/Typography';

const HomePageSignUpLink: React.FC = () => {
  const { openSignUpModal, openSignInModal } = useGlobalModalsContext();

  return (
    <Text>
      or <Link onClick={openSignUpModal}>sign up</Link> /{' '}
      <Link onClick={openSignInModal}>sign in</Link> to create your own
    </Text>
  );
};

export default HomePageSignUpLink;
